import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data7_6_default } from './data';
import { data7_6_1_default } from './data7_6_1';
import './index.scss';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";

const { TextArea } = Input;
const { MonthPicker } = DatePicker;

function numChange(text = '0') {

    let html = Number(text || '0') < 0 ?
        <span style={{ color: "red" }}>
            ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
        </span>
        :
        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return html;

}

function numConvert(num = 0) {
    num = Number(num || "0")
    return num
};

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            data7_6_1: [{
                'comments': ''
            }],
            loading: true,
            print: false,
            loadingSave: false,
            loadingNote: false
        }
    }


    componentDidMount() {
        this.getTable7_6(this.state.date);
        this.getTable7_6_1(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {
        for (let i = 0; i < data.length; i++) {
            data[i].total_hours = numConvert(data[i].duration_hours) * numConvert(data[i].participants_num).toFixed(2)
        }
        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getTable7_6 = (date) => {
        const dataBegin = JSON.stringify(data7_6_default);
        let data = JSON.parse(dataBegin);

        fetch(`/_7_6_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }
            this.setState({
                loading: false,
            });
            this.computeNum(data)
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }

    getTable7_6_1 = (date) => {
        const dataBegin = JSON.stringify(data7_6_1_default);
        let data = JSON.parse(dataBegin);

        fetch(`/_7_6_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }

            this.setState({
                loading: false,
                data7_6_1: data
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        this.onSave7_6_1();
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_7_6', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getTable7_6(this.state.date);
                    this.getTable7_6_1(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }
    onSave7_6_1 = () => {
        this.setState({ loadingNote: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            this.setState({ loadingNote: false });
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data7_6_1.map(x => ({ ...x, year, }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_7_6_1', headres).then(x => x.json()).then(x => {
            this.setState({ loadingNote: false });
            if (x.status == 1) {
                return
            }
            message.error(x.msg);
        }).catch(err => {
            this.setState({ loadingNote: false });
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table7_6', 1.5, '7.60', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    onFillLastMonth = () => {
        if (this.state.data[0] && this.state.data[0].id) {
            message.error('当前月份数据已存在!')
            this.setState({ loading: false });
            return
        }
        this.setState({ loading: true, data: [] });
        const date = moment(this.state.date).subtract(1, 'month').format('YYYY-MM');
        const dataBegin = JSON.stringify(data7_6_default);
        let data = JSON.parse(dataBegin);
        fetch(`/_7_6_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            message.info('数据填充成功！');
            if (x.data && x.data.length > 0) {
                data = x.data.map(v => {
                    delete v.id;
                    delete v.month;
                    delete v.year;
                    return v
                });
            }
            this.setState({ loading: false, });
            this.computeNum(data)
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    render() {
        const data = this.state.data;
        const columns = [{
            title: 'Training Topics 培训主题',
            dataIndex: 'training_topics',
            key: 'training_topics',
            align: "center",
            // fixed: "left",
            // width: 100,
            render: (text, record, index) => {
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                this.onChange('training_topics', value, index)
                            }}
                        />
                    </div>
                )
            }
        }, {
            title: 'Department 部门',
            dataIndex: 'department',
            key: 'department',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                this.onChange('department', value, index)
                            }}
                        />
                    </div>
                )
            }
        }, {
            title: 'Facilitator 培训师',
            dataIndex: 'facilitator',
            key: 'facilitator',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                this.onChange('facilitator', value, index)
                            }}
                        />
                    </div>
                )
            }
        }, {
            title: 'Title 职称',
            dataIndex: 'title',
            key: 'title',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                this.onChange('title', value, index)
                            }}
                        />
                    </div>
                )
            }
        }, {
            title: <div>Duration (Hours)<br />单课课时</div>,
            dataIndex: 'duration_hours',
            key: 'duration_hours',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                return (
                    <div className="table-color table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={0}
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(2));
                                this.onChange('duration_hours', value, index)
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>No. of Participants<br />预计受训人数</div>,
            dataIndex: 'participants_num',
            key: 'participants_num',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                return (
                    <div className="table-color table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={0}
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(2));
                                this.onChange('participants_num', value, index)
                            }}
                        />
                    </div>
                )
            }
        }, {
            title: <div>Total Hours<br />总计课时</div>,
            dataIndex: 'total_hours',
            key: 'total_hours',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                const title = ['Total Hours 总计课时'];

                return (
                    <Compared data={{ index, key: 'total_hours', title, sqlName: "_7_6", name: record.name, type: 'number' }}>
                        <div className={'table-padding'}>
                            {numChange(text)}
                        </div>
                    </Compared>
                    // <div className="table-color table-color-number">
                    //     <Input
                    //         className="input-width"
                    //         precision={0}
                    //         defaultValue={text}
                    //         onBlur={(e) => {
                    //             let value = e.target.value || "0";
                    //             this.onChange('total_hours', value, index)
                    //         }}
                    //     />
                    // </div>
                )
            }
        }, {
            title: 'Remarks 备注',
            dataIndex: 'remarks',
            key: 'remarks',
            align: "center",
            // width: 100,
            render: (text, record, index) => {
                return (
                    <div className="table-color table-color-number">
                        <Input
                            className="input-width"
                            precision={0}
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "0";
                                this.onChange('remarks', value, index)
                            }}
                        />
                    </div>
                )
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1 table7_6" id="table7_6" >
                    <Row className="title">
                        <Row>7.6 Training Plan For Next 1 Month 后一个月主要培训计划</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: []
                                    });
                                    this.getTable7_6(str)
                                    this.getTable7_6_1(str)
                                }}
                            />
                            <Button
                                type="primary"
                                style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                onClick={this.onFillLastMonth}
                            >填充上月数据</Button>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            scroll={{ y: 600 }}
                            rowKey={(record, index) => index}
                        />
                        {/* <Auth loading={this.state.loading} auth="edit_7_6">
                            <Row className="table-footer-btn" style={{ display: this.state.print ? 'none' : "" }}>
                                <Button
                                    type="primary"
                                    onClick={this.onSave}
                                    loading={this.state.loadingSave}
                                >保存</Button>
                            </Row>
                        </Auth> */}
                    </Row>
                    <Row className="title">
                        <Row>7.6.1 Comments备注: </Row>
                        <TextArea
                            autosize={{ minRows: 4 }}
                            value={this.state.data7_6_1[0] ? this.state.data7_6_1[0]['comments'] : ''}
                            onChange={(e) => {
                                let data7_6_1 = this.state.data7_6_1;
                                data7_6_1[0]['comments'] = e.target.value;
                                this.setState({
                                    data7_6_1
                                })
                            }}

                        />
                        <Auth loading={this.state.loading} auth="edit_7_6">
                            <Row className="table-footer-btn" style={{ display: this.state.print ? 'none' : "" }}>
                                <Button
                                    type="primary"
                                    style={{ marginRight: 10 }}
                                    onClick={this.downloadSG}
                                    loading={this.state.print}
                                >加入pdf</Button>
                                <Button
                                    type="primary"
                                    onClick={this.onSave}
                                    loading={this.state.loadingNote}
                                >保存</Button>
                            </Row>
                        </Auth>

                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-6/index.js